import { useApolloClient } from "@apollo/client";
import { EstadisticasDsKeyDtSourceImplGql } from "../../data/datasources/EstadisticasDsKeyDtSourceImplGql";
import { EstadisticasDsKeyRepositoryImpl } from "../../data/repository/EstadisticasDsKeyRepositoryImpl";
import { FechaParams, GetEstadoLlavesAnualParams } from "../../utils/params/EstadisticasDsKey.params";
import { GetEstadisticasLlavesUseCase } from "../../bussines/useCases/GetEstadisticasLlavesUseCase";
import { executeUseCase } from "src/views/core/helpers/executeUseCase";
import { GetLlavesAnuladasMesUseCase } from "../../bussines/useCases/GetLlavesAnuladasMesUseCase";
import { GetLlavesPorExpirarUseCase } from "../../bussines/useCases/GetLlavesPorExpirarUseCase";
import { GetEstadoLlavesAnualUseCase } from "../../bussines/useCases/GetEstadoLlavesAnualUseCase";
import { GetResumenLlavesUseCase } from "../../bussines/useCases/GetResumenLlavesUseCase";

export const useEstadisticasDsKey = () => {
    const apolloClient = useApolloClient();
    const conceptosDtSourceGql = new EstadisticasDsKeyDtSourceImplGql(apolloClient);
    const repository = new EstadisticasDsKeyRepositoryImpl(conceptosDtSourceGql);

    const getEstadisticasLlaves = async (input: FechaParams) => {
        const getEstadisticasLlavesUseCase = new GetEstadisticasLlavesUseCase(repository);
        const result = await executeUseCase({input, useCase: getEstadisticasLlavesUseCase});
        return result;
    };

    const getLlavesAnuladasMes =  async (input: FechaParams) => {
        const getLlavesAnuladasMesUseCase = new GetLlavesAnuladasMesUseCase(repository);
        const result = await executeUseCase({input, useCase: getLlavesAnuladasMesUseCase});
        return result
    };

    const getLlavesPorExpirar = async () => {
        const getLlavesPorExpirarUseCase = new GetLlavesPorExpirarUseCase(repository);
        const result = await executeUseCase({input: null, useCase: getLlavesPorExpirarUseCase});
        return result;
    };

    const getEstadoLlavesAnual = async (input: GetEstadoLlavesAnualParams) => {
        const getEstadoLlavesAnualUseCase = new GetEstadoLlavesAnualUseCase(repository);
        const result = await executeUseCase({input, useCase: getEstadoLlavesAnualUseCase});
        return result;
    };

    const getResumenLlaves = async (input: FechaParams) => {
        const getResumenLlavesUseCase = new GetResumenLlavesUseCase(repository);
        const result = await executeUseCase({input, useCase: getResumenLlavesUseCase});
        return result;
    }

    return {
        getEstadisticasLlaves,
        getLlavesAnuladasMes,
        getLlavesPorExpirar,
        getEstadoLlavesAnual,
        getResumenLlaves
    };
};